import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";

// export const exportToPDF = (htmlContent, fileName) => {
//   const container = document.createElement('div');
//   container.innerHTML = htmlContent;
//   document.body.appendChild(container);
  
//   const buttonElements = container.querySelectorAll('button, script');
//   buttonElements.forEach(button => button.remove());
  
//   container.style.position = 'absolute';
//   container.style.left = '-9999px';
  
//   html2canvas(container, { 
//     scale: 2,
//     useCORS: true,
//     logging: false,
//     allowTaint: true
//   }).then(canvas => {
//     document.body.removeChild(container);
    
//     const imgData = canvas.toDataURL('image/png');
    
//     const pdf = new jsPDF({
//       orientation: 'portrait',
//       unit: 'mm',
//       format: 'a4'
//     });
    
//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();
//     const imgWidth = canvas.width;
//     const imgHeight = canvas.height;
//     const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//     const imgX = (pdfWidth - imgWidth * ratio) / 2;
//     const imgY = 30;
    
//     pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
    
//     const pageCount = Math.ceil(imgHeight * ratio / pdfHeight);
//     if (pageCount > 1) {
//       for (let i = 1; i < pageCount; i++) {
//         pdf.addPage();
//         pdf.addImage(
//           imgData, 
//           'PNG', 
//           imgX, 
//           -(pdfHeight * i - 10), 
//           imgWidth * ratio, 
//           imgHeight * ratio
//         );
//       }
//     }
    
//     pdf.save(fileName + '.pdf');
//   });
// };
// export const exportToPDF = (htmlContent, fileName) => {
//   const container = document.createElement('div');
//   container.innerHTML = htmlContent;
//   document.body.appendChild(container);

//   const buttonElements = container.querySelectorAll('button, script');
//   buttonElements.forEach(button => button.remove());

//   container.style.position = 'absolute';
//   container.style.left = '-9999px';
//   container.style.top = '0';

//   const scaleFactor = 2; // Higher = better quality

//   html2canvas(container, {
//     scale: scaleFactor,
//     useCORS: true,
//     logging: false,
//     allowTaint: true,
//     windowWidth: container.scrollWidth,
//   }).then(canvas => {
//     document.body.removeChild(container);

//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4');

//     const pdfWidth = pdf.internal.pageSize.getWidth();
//     const pdfHeight = pdf.internal.pageSize.getHeight();

//     const imgWidth = canvas.width;
//     const imgHeight = canvas.height;

//     const ratio = pdfWidth / imgWidth;
//     const scaledImgHeight = imgHeight * ratio;

//     let position = 0;
//     let pageHeightLeft = scaledImgHeight;

//     let pageCount = 0;

//     while (pageHeightLeft > 0) {
//       const currentHeight = Math.min(pdfHeight, pageHeightLeft);

//       pdf.addImage(
//         imgData,
//         'PNG',
//         0,
//         0 - position,
//         pdfWidth,
//         scaledImgHeight
//       );

//       pageHeightLeft -= pdfHeight;
//       position += pdfHeight;

//       if (pageHeightLeft > 0) {
//         pdf.addPage();
//       }

//       pageCount++;
//     }

//     pdf.save(fileName + '.pdf');
//   });
// };
export const exportToPDF = (htmlContent, fileName) => {
  const container = document.createElement('div');
  container.innerHTML = htmlContent;
  document.body.appendChild(container);

  const buttonElements = container.querySelectorAll('button, script');
  buttonElements.forEach(button => button.remove());

  container.style.position = 'absolute';
  container.style.left = '-9999px';
  container.style.top = '0';

  const scaleFactor = 2; // Higher = better quality

  html2canvas(container, {
    scale: scaleFactor,
    useCORS: true,
    logging: false,
    allowTaint: true,
    windowWidth: container.scrollWidth,
  }).then(canvas => {
    document.body.removeChild(container);

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const ratio = pdfWidth / imgWidth;
    const scaledImgHeight = imgHeight * ratio;

    let position = 0;
    let pageHeightLeft = scaledImgHeight;

    const marginBetweenPages = 15; // gap size in mm

    while (pageHeightLeft > 0) {
      pdf.addImage(
        imgData,
        'PNG',
        0,
        -position,
        pdfWidth,
        scaledImgHeight
      );

      pageHeightLeft -= (pdfHeight - marginBetweenPages);
      position += (pdfHeight - marginBetweenPages);

      if (pageHeightLeft > 0) {
        // Add separator line at the bottom of the page
        pdf.setDrawColor(150); // gray line
        pdf.setLineWidth(0.2);
        pdf.line(10, pdfHeight - marginBetweenPages / 2, pdfWidth - 10, pdfHeight - marginBetweenPages / 2);

        pdf.addPage();
      }
    }

    pdf.save(fileName + '.pdf');
  });
};

export const getPDFBlob = (htmlContent) => {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    container.innerHTML = htmlContent;
    // Set a fixed width to ensure consistent scaling
    container.style.width = '800px'; 
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    document.body.appendChild(container);
    
    const buttonElements = container.querySelectorAll('button, script');
    buttonElements.forEach(button => button.remove());
    
    html2canvas(container, { 
      scale: 1.5, // Reduced from default/high scales to save memory
      useCORS: true,
      logging: false,
    }).then(canvas => {
      document.body.removeChild(container);
      
      // FIX 1: Use JPEG instead of PNG and set quality to 0.7 (70%)
      const imgData = canvas.toDataURL('image/jpeg', 0.7);
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
        compress: true // FIX 2: Enable internal PDF compression
      });
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = pdfWidth / imgWidth;
      
      // Add first page
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, imgHeight * ratio);
      
      // Handle multi-page
      let heightLeft = imgHeight * ratio;
      let position = 0;

      while (heightLeft >= pdfHeight) {
        position = heightLeft - imgHeight * ratio;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, imgHeight * ratio);
        heightLeft -= pdfHeight;
      }
      
      resolve(pdf.output('blob'));
    }).catch(err => reject(err));
  });
};
// export const getPDFBlob = (htmlContent) => {
//   return new Promise((resolve, reject) => {
//     const container = document.createElement('div');
//     container.innerHTML = htmlContent;
//     document.body.appendChild(container);
    
//     const buttonElements = container.querySelectorAll('button, script');
//     buttonElements.forEach(button => button.remove());
    
//     container.style.position = 'absolute';
//     container.style.left = '-9999px';
    
//     html2canvas(container, { 
//       scale: 1,
//       useCORS: true,
//       logging: false,
//       allowTaint: true
//     }).then(canvas => {
//       document.body.removeChild(container);
      
//       const imgData = canvas.toDataURL('image/png');
      
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'mm',
//         format: 'a4'
//       });
      
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = pdf.internal.pageSize.getHeight();
//       const imgWidth = canvas.width;
//       const imgHeight = canvas.height;
//       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
//       const imgX = (pdfWidth - imgWidth * ratio) / 2;
//       const imgY = 30;
      
//       pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      
//       const pageCount = Math.ceil(imgHeight * ratio / pdfHeight);
//       if (pageCount > 1) {
//         for (let i = 1; i < pageCount; i++) {
//           pdf.addPage();
//           pdf.addImage(
//             imgData, 
//             'PNG', 
//             imgX, 
//             -(pdfHeight * i - 10), 
//             imgWidth * ratio, 
//             imgHeight * ratio
//           );
//         }
//       }
      
//       const pdfBlob = pdf.output('blob');
//       resolve(pdfBlob);
//     }).catch(error => {
//       reject(error);
//     });
//   });
// };

export const exportToExcel = (data, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
